import type { Community, NucampUser, geoLocation } from "$lib/datamodel";
import { derived, type Writable } from "svelte/store";
import { fetchRetry, urlFix } from "$lib/helpers";
import { geolocation } from "./nucamp-geolocation";
import { user } from "./nucamp-user";


export const community = derived<[Writable<geoLocation>, Writable<NucampUser>], Community | null>([geolocation, user], ([$geolocation, $user], set) => {
  const data = { 
    lat: "",
    lng: "",
    number: "",
    communityCollection: "",
    urlId: ""
  };

  if ($geolocation?.latitude && $geolocation.longitude && !($user?.location && $user?.state)) {
    data.lat = $geolocation.latitude.toString();
    data.lng = $geolocation.longitude.toString();
    data.number = "6";
    data.communityCollection = "community";
  } else if ($user?.location && $user?.state) {
    data.urlId = `${$user.state.toLowerCase()}/${urlFix($user.location)}`
  }
  if (data.lat || data.urlId) {
    const searchParams = new URLSearchParams(data);
    const searchParamsString = searchParams.toString();
    fetchRetry('/api/community?' + searchParamsString, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json'
      },
    }, {retries: 3, retryDelay: 500})
    .then((res) => res.json())
    .then((nearestCommunity) => {
      set(nearestCommunity as Community)
    });
  } else {
    set(null);
  }

})
